import API from "serviceshift-ui/api-client";

export default {
  createMembershipProgram({ dispatch }, params) {
    return API.membershipProgram.create(params).then(() => {
      return dispatch("fetchMembershipPrograms");
    });
  },
  createWarrantyProgram({ dispatch }, params) {
    return API.warrantyProgram.create(params).then(() => {
      return dispatch("fetchWarrantyPrograms");
    });
  },
  fetchCustomizations({ commit }) {
    return API.makeRequest("/customizations.json", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "customizations",
        data: res.data
      });
    });
  },
  fetchTenantCustomizations({ commit }) {
    // Get tenant id from url
    const subdomain = window.location.hostname.split(".")[0];
    return API.tenant.getCustomizations(subdomain).then((res) => {
      commit("replace", {
        state: "tenantCustomizations",
        data: res.data
      });
    });
  },
  fetchTenant({ commit }) {
    // Get tenant id from url
    const subdomain = window.location.hostname.split(".")[0];
    commit("replace", {
      state: "fetchingTenant",
      data: true
    });
    return API.tenant
      .getBySubdomain(subdomain)
      .then((res) => {
        commit("replace", {
          state: "tenant",
          data: res.data
        });
        commit("replace", {
          state: "fetchingTenant",
          data: false
        });
      })
      .catch(() => {
        commit("replace", {
          state: "fetchingTenant",
          data: false
        });
      });
  },
  fetchPaymentMethods({ commit }) {
    return API.tenant.getPaymentMethods().then((res) => {
      commit("replace", {
        state: "paymentMethods",
        data: res.data
      });
    });
  },
  fetchPaymentMethodsSettings({ commit }) {
    return API.tenant.getPaymentMethodsSettings().then((res) => {
      commit("replace", {
        state: "paymentMethodsSettings",
        data: res.data
      });
    });
  },
  setTimezoneOptions({ commit }, data) {
    commit("replace", {
      state: "timezones",
      data
    });
  },
  updateMembershipProgram({ dispatch }, params) {
    return API.membershipProgram.update(params).then(() => {
      return dispatch("fetchMembershipPrograms");
    });
  },
  updateWarrantyProgram({ dispatch }, params) {
    return API.warrantyProgram.update(params).then(() => {
      return dispatch("fetchWarrantyPrograms");
    });
  },
  updatePaymentMethodsSettings({ commit }, data) {
    return API.tenant.updatePaymentMethodsSettings(data).then((res) => {
      commit("replace", {
        state: "paymentMethodsSettings",
        data: res.data
      });
    });
  },
  fetchIntegrations({ commit }) {
    return API.makeRequest("/v2/settings/integrations.json", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "integrations",
        data: res.data
      });
    });
  },
  fetchZapierIntegrations({ commit }) {
    return API.makeRequest("/v2/zapier_integrations.json", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "zapierIntegrations",
        data: res.data
      });
    });
  },
  fetchCampDigitalIntegrations({ commit }) {
    return API.makeRequest("/v2/integration/camp_digital.json", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "campDigitalConfig",
        data: res.data
      });
    });
  },
  updateIntegrations({ commit }, integrations) {
    return API.makeRequest("/v2/settings/integrations.json", {
      method: "POST",
      data: integrations
    }).then((res) => {
      commit("replace", {
        state: "integrations",
        data: res.data
      });
    });
  },
  updateZapierIntegrations({ commit }, zapierIntegrations) {
    return API.makeRequest("/v2/zapier_integrations/toggle.json", {
      method: "POST",
      data: zapierIntegrations
    }).then((res) => {
      commit("replace", {
        state: "zapierIntegrations",
        data: res.data
      });
    });
  },
  updateCampDigitalIntegrations({ commit }, campDigitalConfig) {
    return API.makeRequest("/v2/integration/camp_digital/toggle.json", {
      method: "POST",
      data: campDigitalConfig
    }).then((res) => {
      commit("replace", {
        state: "campDigitalConfig",
        data: res.data
      });
    });
  },
  fetchCallRail({ commit }) {
    return API.makeRequest("/v2/call_rail.json", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "callRail",
        data: res.data
      });
    });
  },
  changeCallRail({ commit }, config) {
    return API.makeRequest("/v2/call_rail.json", {
      method: "POST",
      data: config
    }).then((res) => {
      commit("replace", {
        state: "callRail",
        data: res.data
      });
    });
  },
  dropCallRail({ commit }) {
    return API.makeRequest("/v2/call_rail.json", {
      method: "DELETE"
    }).then((res) => {
      commit("replace", {
        state: "callRail",
        data: res.data
      });
    });
  },
  fetchJBWarranties({ commit }) {
    return API.makeRequest("/v2/integration/jb_warranties", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "jbWarranties",
        data: res.data
      });
    });
  },
  changeJBWarranties({ commit }, config) {
    return API.makeRequest("/v2/integration/jb_warranties", {
      method: "POST",
      data: config
    }).then((res) => {
      commit("replace", {
        state: "jbWarranties",
        data: res.data
      });
    });
  },
  validateJBWarranties({ commit }, config) {
    return API.makeRequest("/v2/integration/jb_warranties/validate", {
      method: "POST",
      data: config
    }).then((res) => {
      return res.data;
    });
  },
  dropJBWarranties({ commit }) {
    return API.makeRequest("/v2/integration/jb_warranties", {
      method: "DELETE"
    }).then((res) => {
      commit("replace", {
        state: "jbWarranties",
        data: res.data
      });
    });
  },
  fetchStaxPayments({ commit }) {
    return API.makeRequest("/v2/integration/stax_payments", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "staxPayments",
        data: res.data
      });
    });
  },
  changeStaxPayments({ commit }, config) {
    return API.makeRequest("/v2/integration/stax_payments", {
      method: "POST",
      data: config
    }).then((res) => {
      commit("replace", {
        state: "staxPayments",
        data: res.data
      });
    });
  },
  dropStaxPayments({ commit }) {
    return API.makeRequest("/v2/integration/stax_payments", {
      method: "DELETE"
    }).then((res) => {
      commit("replace", {
        state: "staxPayments",
        data: res.data
      });
    });
  },
  async fetchServiceFinanceConfig({ commit }) {
    const res = await API.makeRequest("/v2/integration/service_finance", {
      method: "GET"
    });
    commit("replace", {
      state: "serviceFinance",
      data: res.data
    });
  },
  async changeServiceFinanceConfig({ commit }, config) {
    const res = await API.makeRequest("/v2/integration/service_finance", {
      method: "POST",
      data: config
    });
    commit("replace", {
      state: "serviceFinance",
      data: res.data
    });
  },
  async dropServiceFinanceIntegration({ commit }) {
    const res = await API.makeRequest("/v2/integration/service_finance", {
      method: "DELETE"
    });
    commit("replace", {
      state: "serviceFinance",
      data: res.data
    });
  },
  fetchBluonIntegration({ commit }) {
    return API.makeRequest("/v2/integration/bluon", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "bluonIntegration",
        data: res.data
      });
    });
  },
  changeBluonIntegration({ commit }, config) {
    return API.makeRequest("/v2/integration/bluon", {
      method: "POST",
      data: config
    }).then((res) => {
      commit("replace", {
        state: "bluonIntegration",
        data: res.data
      });
    });
  },
  fetchRingCentral({ commit }) {
    return API.makeRequest("/v2/ring_central", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "ringCentral",
        data: res.data
      });
    });
  },
  changeRingCentral({ commit }, config) {
    return API.makeRequest("/v2/ring_central", {
      method: "POST",
      data: config
    }).then((res) => {
      commit("replace", {
        state: "ringCentral",
        data: res.data
      });
    });
  },
  async dropRingCentral({ commit }) {
    const res = await API.makeRequest("/v2/ring_central", {
      method: "DELETE"
    });
    commit("replace", {
      state: "ringCentral",
      data: res.data
    });
  }
};
